import React, { useState } from 'react';
import { FaBriefcase, FaGraduationCap } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import './Journey.css';

const Journey = () => {
  const darkTheme = useTheme();
  const [activeTab, setActiveTab] = useState('experience');

  const experiences = [
    {
      icon: <FaBriefcase />,
      title: 'TechieAid',
      subtitle: 'Frontend Developer',
      date: 'July 2023 - September 2023'
    },
    {
      icon: <FaBriefcase />,
      title: 'Accenture',
      subtitle: 'SQL Developer, Data Engineer with Snowflake',
      date: 'July 2024 - Present',
    },
  ];

  const education = [
    {
      icon: <FaGraduationCap />,
      title: 'Bihar Public School',
      subtitle: 'Matriculation',
      date: '2016 - 2017',
    },
    {
      icon: <FaGraduationCap />,
      title: 'Bihar Public School',
      subtitle: '12th',
      date: '2017 - 2019',
    },
    {
      icon: <FaGraduationCap />,
      title: 'RNS Institute of Technology',
      subtitle: 'B.Tech in Information Technology',
      date: '2020 - 2024',
    },
  ];

  const data = activeTab === 'experience' ? experiences : education;

  // 🎨 Centralized theme styles
  const themeStyles = {
    container: {
      backgroundColor: darkTheme ? 'rgb(29,42,53)' : 'rgb(252, 249, 242)',
      // color: darkTheme ? '#eeeeee' : '#1d1f27',
    },
    tabButton: {
      padding: '10px 20px',
      border: '2px solid #ff8a00',
      backgroundColor: darkTheme ? '#2a2a2a' : '#fff2e0',
      color: darkTheme ? '#eeeeee' : '#333',
      fontWeight: 'bold',
      borderRadius: '30px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },

    tabButtonActive: {
      background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
      color: '#ffffff',
      border: '2px solid transparent', // override previous border
      backgroundColor: 'transparent', // ensure gradient is shown
    },


    stepperIcon: {
      background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
      color: '#ffffff',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      position: 'absolute',
      left: '0',
      top: '0',
      zIndex: 1,
    },
    stepperLine: {
      background: '#e52e71',
      position: 'absolute',
      left: '11px',
      top: '24px',
      width: '2px',
      height: 'calc(100% - 24px)',
      zIndex: 0,
    },
    stepperContent: {
      background: darkTheme ? 'rgb(22, 32, 42)' : 'rgb(252, 249, 242)',
      borderRadius: '12px',
      padding: '15px 20px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
    },
    stepperTitle: {
      margin: 0,
      // fontSize: '1.1em',
      fontWeight: 600,
      color: darkTheme ? '#ffffff' : '#333',
    },
    stepperSubtitle: {
      margin: '5px 0',
      // fontSize: '0.95em',
      color: darkTheme ? '#bbbbbb' : '#555',
    },
    stepperDate: {
      // fontSize: '0.85em',
      color: darkTheme ? '#999999' : '#888',
      fontStyle: 'italic',
    },
  };

  return (
    <section className="journey-container" id="myjourney" style={themeStyles.container}>
      <h2 className="journey-heading">My Journey</h2>

      <div className="tab-buttons">
        <button
          style={{
            ...themeStyles.tabButton,
            ...(activeTab === 'experience' ? themeStyles.tabButtonActive : {}),
          }}
          onClick={() => setActiveTab('experience')}
        >
          My Experience
        </button>
        <button
          style={{
            ...themeStyles.tabButton,
            ...(activeTab === 'education' ? themeStyles.tabButtonActive : {}),
          }}
          onClick={() => setActiveTab('education')}
        >
          Education
        </button>
      </div>

      <div className="stepper">
        {data.map((item, index) => (
          <div className="stepper-item" key={index}>
            <div className="stepper-icon" style={themeStyles.stepperIcon}>
              {item.icon}
            </div>
            <div className="stepper-line" style={themeStyles.stepperLine} />
            <div className="stepper-content" style={themeStyles.stepperContent}>
              <h3 className="stepper-title" style={themeStyles.stepperTitle}>
                {item.title}
              </h3>
              <p className="stepper-subtitle" style={themeStyles.stepperSubtitle}>
                {item.subtitle}
              </p>
              <p className="stepper-date" style={themeStyles.stepperDate}>
                {item.date}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Journey;
